import { Action, Dispatch } from "redux";
import { ConfirmDropProductDto } from "../../dto/network/ConfirmDropProductDto";
import { BillDto } from "../../dto/vending/BillDto";
import { QrCodeDto } from "../../dto/vending/QrCodeDto";
import { ResOtpAcquireUserDto } from "../../dto/vending/ResOtpAcquireUserDto";
import { ResPromotionAcquireUserDto } from "../../dto/vending/ResPromotionAcquireUserDto";
import { ResPromotionGiftVoucherDto } from "../../dto/vending/ResPromotionGiftVoucherDto";
import { FGetState } from "../app.reducer";

/**
 * Functon type declare
 */
export type FuncAction = (
  dispatch: Dispatch,
  getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Cart action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BILL: {
    LOADING: "BILL_LOADING",
    SUCCESS: "BILL_SUCCESS",
    FAIL: "BILL_FAIL",
    BILL_NUMBER: "BILL_NUMBER",
    BILL_QRCODE: "BILL_QRCODE",
    ERROR: "BILL_ERROR",
    LOYALTY: "BILL_LOYALTY",
    VOUCHER: "BILL_VOUCHER",
    CLEAN_DATA: "BILL_CLEAN_DATA",
    START_LOADING: "START_LOADING",
    STOP_LOADING: "STOP_LOADING",
    ACQUIRE_USER: "BILL_ACQUIRE_USER",
    CLEAR_ACQUIRE_USER: "CLEAR_ACQUIRE_USER",
    OTP_ACQUIRE_USER: "BILL_OTP_ACQUIRE_USER",
    RETRY_DROP_PRODUCT: "BILL_RETRY_DROP_PRODUCT",
    UPDATE_SOCKET: "BILL_UPDATE_SOCKET",
    GET_BILL: "BILL_GET_BILL",
    GET_CHARITY_FUND: "GET_CHARITY_FUND",
    GET_BANK: "GET_BANK",
  },

};

/**
 * All store state
 */
export interface BillState {
  isLoading?: Boolean,
  error?: any,
  bill: BillDto,
  promotionVoucherLoyalty: any,
  promotionGiftVoucher: ResPromotionGiftVoucherDto,
  promotionAcquireUser: ResPromotionAcquireUserDto,
  otpAcquireUser: ResOtpAcquireUserDto;
  confirmDropProduct: ConfirmDropProductDto,
  billInfo: ConfirmDropProductDto,
  qrCode: QrCodeDto,
  resBill: any,
  charityFund: any,
  bankList: any,
}

/**
 * Cart's action definition
 */
export interface IBillAction extends Action {
  payload: any;
  error: any;
}
